export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/Seller_speak_icon.c0083ad.svg";